import Vue from 'vue';

import {baseEditor} from "./baseEditor";

import {zodiacStyles} from "./zodiac/zodiacStyles";
import Zoom from "../components/editor/ui/Zoom";
import ZodiacTabs from "../components/editor/ui/tabs/ZodiacTabs";

import * as Sentry from '@sentry/vue';

Sentry.init({
    Vue: Vue,
    dsn: "https://1ad7802d9ae04ae1b40a22db5165f014@o99457.ingest.sentry.io/5611590",
});

window.bus = new Vue({});

const app = new Vue({
    el: '#app',
    mixins: [
        baseEditor
    ],

    components: {
        Zoom,

        ZodiacTabs,
    },

    watch: {
        'print.date': function () {
            // const date = new Date(this.print.date);
            //
            // this.print.subtitle = date.toLocaleDateString('nl-nl', {year: 'numeric', month: '2-digit', day: '2-digit'});
            //
            // // thanks; https://medium.com/@Saf_Bes/get-the-zodiac-sign-for-a-date-in-javascript-797305d75869
            // const signs = Object.keys(this.zodiacDates)
            // const sign = Number(new Intl.DateTimeFormat('fr-TN-u-ca-persian', {month: 'numeric'}).format(date)) - 1;
            //
            // console.log(signs[sign]);
            //
            // this.print.zodiac = signs[sign]
            // this.print.tagline = this.zodiacSigns[signs[sign]].nl
        }
    },

    computed: {
        computedPrintConfig() {
            return zodiacStyles.find(item => item.slug === this.print.design) || zodiacStyles[0]
        },

        zodiacDates() {
            return {
                'aries': {"name": "Aries", from: "21-03", to: "19-04", monogram: "AriesMonogram"},
                'taurus': {"name": "Taurus", from: "20-04", to: "20-05", monogram: "TaurusMonogram"},
                'gemini': {"name": "Gemini", from: "21-05", to: "21-06", monogram: "GeminiMonogram"},
                'cancer': {"name": "Cancer", from: "22-06", to: "22-07", monogram: "CancerMonogram"},
                'leo': {"name": "Leo", from: "23-07", to: "22-08", monogram: "LeoMonogram"},
                'virgo': {"name": "Virgo", from: "23-08", to: "22-09", monogram: "VirgoMonogram"},
                'libra': {"name": "Libra", from: "23-09", to: "23-10", monogram: "LibraMonogram"},
                'scorpio': {"name": "Scorpio", from: "24-10", to: "21-11", monogram: "ScorpioMonogram"},
                'sagittarius': {"name": "Sagittarius", from: "22-11", to: "21-12", monogram: "SagittariusMonogram"},
                'capricorn': {"name": "Capricorn", from: "22-12", to: "19-01", monogram: "CapricornMonogram"},
                'aquarius': {"name": "Aquarius", from: "20-01", to: "18-02", monogram: "AquariusMonogram"},
                'pisces': {"name": "Pisces", from: "19-02", to: "20-03", monogram: "PiscesMonogram"},
            }
        },

        zodiacSigns() {
            return {
                // "sidebar": {
                //     "addToCartText": "Add to cart",
                //     "addToCartSave": "and save {savings} or more",
                //     "title": "Customize your design",
                //     "description": "Change zodiac, labels and appearance",
                //     "zodiac": {
                //         "zodiacLabel": "Zodiac",
                //         "datePickerLabel": "Birthday",
                //         "datePickerDescription": "Enter your birthday",
                //         "datePickerPlaceholder": "Pick a day",
                //         "selectPlaceholder": "Select sign",
                //         "hint": "<strong>Hint!</strong> Changing date, or zodiac sign will update the text on the poster. You can change this yourself at anytime in the section <em>Customize the text</em>.",
                //         "title": "Customize sign",
                //         "mobileTitle": "Customize sign",
                //         "attributeLabel": "Attributes",
                //         "zodiacAttributes": {
                //             "title": "Symbol",
                //             "latin": "Latin name",
                //             "stone": "Birth stone",
                //             "planet": "Planet",
                //             "element": "Element"
                //         }
                //     },
                //     "size": {
                //         "sizeLabel": "Size",
                //         "title": "Change the size",
                //         "mobileTitle": "Size",
                //         "toggleLabel": "Switch size standards",
                //         "toggleCM": "CM (EU)",
                //         "toggleINCH": "Inch (US)"
                //     },
                //     "orientation": {"portrait": "Portrait", "landscape": "Landscape"},
                //     "style": {
                //         "themeLabel": "Theme",
                //         "title": "Customize the style",
                //         "mobileTitle": "Style",
                //         "includeMonogram": "Include monogram",
                //         "includeStars": "Include stars"
                //     },
                //     "text": {
                //         "dividerLabel": "Divider",
                //         "dividerPlaceholder": "Please input a divider",
                //         "editLabelsText": "Edit all labels",
                //         "headlineLabel": "Headline",
                //         "headlinePlaceholder": "Please input a headline",
                //         "sublineLabel": "Subline",
                //         "sublinePlaceholder": "Please input a subline",
                //         "taglineLabel": "Tagline",
                //         "taglinePlaceholder": "Please input a tagline",
                //         "title": "Customize the text",
                //         "mobileTitle": "Text"
                //     }
                // }, "zodiacSigns":
                // {
                "capricorn": {
                    "title": "The Sea-Goat",
                    "latin": "Capricorn",
                    "nl": "Steenbok",
                    "element": "Earth",
                    "planet": "Saturn",
                    "stone": "Garnet",
                    "traits": ["Responsible", "Ambitious", "Wise"]
                },
                "aquarius": {
                    "title": "The Pitcher",
                    "latin": "Aquarius",
                    "nl": "Waterman",
                    "element": "Air",
                    "planet": "Uranus",
                    "stone": "Amethyst",
                    "traits": ["Progressive", "Imaginative", "Independent"]
                },
                "pisces": {
                    "title": "The Fish",
                    "latin": "Pisces",
                    "nl": "Vissen",
                    "element": "Water",
                    "planet": "Neptune",
                    "stone": "Aquamarine",
                    "traits": ["Compassionate", "Intuitive", "Artistic"]
                },
                "aries": {
                    "title": "The Ram",
                    "latin": "Aries",
                    "nl": "Ram",
                    "element": "Fire",
                    "planet": "Mars",
                    "stone": "Diamond",
                    "traits": ["Enthusiastic", "Dynamic", "Honest"]
                },
                "taurus": {
                    "title": "The Bull",
                    "latin": "Taurus",
                    "nl": "Stier",
                    "element": "Earth",
                    "planet": "Venus",
                    "stone": "Emerald",
                    "traits": ["Patient", "Dependable", "Devoted"]
                },
                "gemini": {
                    "title": "The Twins",
                    "latin": "Gemini",
                    "nl": "Tweeling",
                    "element": "Air",
                    "planet": "Mercury",
                    "stone": "Pearl",
                    "traits": ["Expressive", "Curious", "Witty"]
                },
                "cancer": {
                    "title": "The Crab",
                    "latin": "Cancer",
                    "nl": "Kreeft",
                    "element": "Water",
                    "planet": "Moon",
                    "stone": "Moonstone",
                    "traits": ["Loyal", "Sentimental", "Compassionate"]
                },
                "leo": {
                    "title": "The Lion",
                    "latin": "Leo",
                    "nl": "Leeuw",
                    "element": "Fire",
                    "planet": "Sun",
                    "stone": "Peridot",
                    "traits": ["Energetic", "Outgoing", "Self-assured"]
                },
                "virgo": {
                    "title": "The Virgin",
                    "latin": "Virgo",
                    "nl": "Maagd",
                    "element": "Earth",
                    "planet": "Mercury",
                    "stone": "Blue Saphire",
                    "traits": ["Hardworking", "Loyal", "Trustworthy"]
                },
                "libra": {
                    "title": "The Scale",
                    "latin": "Libra",
                    "nl": "Weegschaal",
                    "element": "Air",
                    "planet": "Venus",
                    "stone": "Opal",
                    "traits": ["Charming", "Diplomatic", "Gracious"]
                },
                "scorpio": {
                    "title": "The Scorpion",
                    "latin": "Scorpio",
                    "nl": "Schorpioen",
                    "element": "Water",
                    "planet": "Pluto",
                    "stone": "Topaz",
                    "traits": ["Passionate", "Resourceful", "Brave"]
                },
                "sagittarius": {
                    "title": "The Centaur",
                    "latin": "Sagittarius",
                    "nl": "Boogschutter",
                    "element": "Fire",
                    "planet": "Jupiter",
                    "stone": "Turquoise",
                    "traits": ["Optimistic", "Funny", "Generous"]
                }
                // }
            }
        }
    },

    data() {
        return {
            type: 'zodiac',
            zodiacStyles,

            showZoom: false,
            showMoveHint: false,

            defaultWidth: 651,
            defaultHeight: 920,

            posterSize: {
                width: 651,
                height: 920,
            },

            colors: {
                'black': {
                    name: 'Zwart',
                    color: 'bg-black',
                    bg: 'bg-gray-100',
                    signColor: 'text-gray-50',
                    text: 'text-gray-900',
                    border: 'border-gray-900',
                },
                'gray': {
                    name: 'Grijs',
                    color: 'bg-gray-300',
                    bg: 'bg-gray-100',
                    signColor: 'text-gray-900',
                    text: 'text-gray-900',
                    border: 'border-gray-900',
                },
                'green': {
                    name: 'Groen',
                    color: 'bg-green-200',
                    bg: 'bg-green-100',
                    signColor: 'text-green-900',
                    text: 'text-green-900',
                    border: 'border-green-900',
                },
                'blue': {
                    name: 'Blauw',
                    color: 'bg-blue-200',
                    bg: 'bg-blue-100',
                    signColor: 'text-blue-900',
                    text: 'text-blue-900',
                    border: 'border-blue-900',
                },
                'pink': {
                    name: 'Roze',
                    color: 'bg-pink-200',
                    bg: 'bg-pink-100',
                    signColor: 'text-pink-900',
                    text: 'text-pink-900',
                    border: 'border-pink-900',
                },
                'yellow': {
                    name: 'Geel',
                    color: 'bg-yellow-200',
                    bg: 'bg-yellow-100',
                    signColor: 'text-yellow-900',
                    text: 'text-yellow-900',
                    border: 'border-yellow-900',
                },
                'dark-green': {
                    name: 'Donker Groen',
                    color: 'bg-green-900',
                    bg: 'bg-green-100',
                    signColor: 'text-green-50',
                    text: 'text-green-900',
                    border: 'border-green-900',
                },
                'dark-blue': {
                    name: 'Donker Blauw',
                    color: 'bg-blue-900',
                    bg: 'bg-blue-100',
                    signColor: 'text-blue-50',
                    text: 'text-blue-900',
                    border: 'border-blue-900',
                },
                'dark-pink': {
                    name: 'Donker Roze',
                    color: 'bg-pink-900',
                    bg: 'bg-pink-100',
                    signColor: 'text-pink-50',
                    text: 'text-pink-900',
                    border: 'border-pink-900',
                },
                'dark-yellow': {
                    name: 'Donker Geel',
                    color: 'bg-yellow-900',
                    bg: 'bg-yellow-100',
                    signColor: 'text-yellow-50',
                    text: 'text-yellow-900',
                    border: 'border-yellow-900',
                },
            },

            initialState: {
                title: 'Naam',
                subtitle: '01-01-2021',
                tagline: 'Steenbok',

                design: 'default',
                material: 'poster',
                size: 'A3',

                monogram: true,
                stars: true,
                zodiac: 'taurus',
                color: 'black',

                date: '2021-01-01',
            },

            bleedStyles: {},
        }
    },
});
